import { render } from "./RedirectPage.vue?vue&type=template&id=7cf1eeed&scoped=true"
import script from "./RedirectPage.vue?vue&type=script&lang=js"
export * from "./RedirectPage.vue?vue&type=script&lang=js"

import "./RedirectPage.vue?vue&type=style&index=0&id=7cf1eeed&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf1eeed"]])

export default __exports__